import React from 'react'
import { useSelector } from 'react-redux'

import { RootState } from '@debbie/cortex/dist/reducer.js'
import { Button } from '@debbie/iris/dist/components/index.js'
import { useAllCreditors } from '@debbie/cortex/dist/creditors/index.js'
import { h } from '@debbie/cortex/dist/index.js'

const CreateCase = () => {
  const lang = useSelector((s: RootState) => s.lang)
  const allCreditorsLoadable = useAllCreditors()

  return (
    <div
      style={{
        display: 'inline-block',
        verticalAlign: 'bottom',
      }}
    >
      {h.hasData(allCreditorsLoadable) && (
        <Button size="small" href="/create-case">
          {lang.cases.createNewCase}
        </Button>
      )}
    </div>
  )
}

export default CreateCase
